module.exports = __webpack_public_path__ + "static/media/DanceAI.f1d1df2e.png";